var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invoiceDetail"},[_c('CommonDetail',{attrs:{"type":"invoice"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }